/**
 * Shared field configuration for Add Group Data and Review/Submit.
 * Defines section groups and their fields.
 */
export const fieldGroups = {
  'Large Gp/Children/Workers': ['largeGroupChurch', 'children', 'childrenWorkers'],
  'Donations, Sales from Books, Food Donation': ['donations', 'salesFromBooks', 'foodDonation'],
  'Teens': ['teens'],
  "Men's Life Issues": ['mensLifeIssues'],
  "Men's Addiction": ['mensAddiction'],
  "Women's Addiction": ['womensAddiction'],
  "Women's Life Issues": ['womensLifeIssues'],
  'New Beginnings': ['newBeginnings'],
  'Baptisms': ['baptisms'],
  'Blue Chips': ['blueChips'],
  'Meals Served': ['mealsServed'],
  'Step Study Graduates': ['stepStudyGraduates']
};

/** User-friendly labels for each field key */
export const fieldLabels = {
  largeGroupChurch: 'Large Group Church',
  children: 'Children',
  childrenWorkers: 'Children Workers',
  blueChips: 'Blue Chips',
  donations: 'Donations',
  salesFromBooks: 'Sales From Books',
  foodDonation: 'Food Donation',
  mealsServed: 'Meals Served',
  teens: 'Teens',
  mensLifeIssues: "Men's Life Issues",
  mensAddiction: "Men's Addiction",
  womensAddiction: "Women's Addiction",
  womensLifeIssues: "Women's Life Issues",
  newBeginnings: 'New Beginnings',
  baptisms: 'Baptisms',
  stepStudyGraduates: 'Step Study Graduates',
  comment: 'Comment'
};

/** Ordered field keys for the full report form (Submit Report / CRForm) */
export const reportFormFieldKeys = [
  'largeGroupChurch', 'children', 'childrenWorkers', 'blueChips',
  'donations', 'salesFromBooks', 'foodDonation', 'mealsServed',
  'teens', 'mensLifeIssues', 'mensAddiction', 'womensAddiction',
  'womensLifeIssues', 'newBeginnings', 'baptisms', 'stepStudyGraduates'
];

/** Initial form state for the full report form */
export const getReportFormInitialState = () => {
  const base = reportFormFieldKeys.reduce((acc, key) => ({ ...acc, [key]: '' }), {});
  return { date: '', ...base };
};
